module.exports = __webpack_public_path__ + "img/icon-system.411c037b.svg";